// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Clipboard from "v-clipboard";
import store from "./store";
import VueProgressBar from "vue-progressbar";
import VeeValidate from "vee-validate";
import ToggleButton from "vue-js-toggle-button";
import numberal from "numeral";
import VueSocketIO from "vue-socket.io";
import appConfig from "@/config";
import {
    BootstrapVue,
    IconsPlugin,
    ToastPlugin,
    ModalPlugin
} from "bootstrap-vue";

// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

import VueCookies from 'vue-cookies'

//install vue-cookies
Vue.use(VueCookies, { expires: '1h', path: '/', secure: true, sameSite: 'Lax'})

//install progress bar
Vue.use(VueProgressBar, {
    color: "#576ae6",
    failedColor: "red",
    height: "2px",
    thickness: "3px"
});

// BSV Plugin Registration
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// install vee-validate
// Vue.use(VeeValidate, {
//     errorBagName: "errors"
// });

Vue.use(VeeValidate);
Vue.use(ToggleButton);
Vue.use(Clipboard);

Vue.use(
    new VueSocketIO({
        debug: true,
        connection: appConfig.api.socket,
        vuex: {
            store,
            actionPrefix: "SOCKET_",
            mutationPrefix: "SOCKET_"
        }
    })
);

Vue.filter("numeralize", (value, format) => numberal(value).format(format));

// Click outside vue directive
Vue.directive("click-outside", {
    bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
            const compName = vNode.context.name;
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
            if (compName) {
                warn += `Found in component '${compName}'`;
            }

            console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = e => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
                binding.value(e);
            }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
    },

    unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
    }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    template: "<App/>",
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js